import { FC } from 'react';
import Select, { Options, components } from 'react-select';
import { selectStyles } from '../selectValue';
import { Img } from 'shared/ui/imgStyledComponent';
import arrow from 'shared/assets/icons/arrow.svg';
import arrowTop from 'shared/assets/icons/arrowTop.svg';
import { ArrowContainer } from './styles';
import { useCalendarDatepicker } from 'shared/lib/selectCalendar';
interface Option {
	value: string;
	label: string;
}

interface SelectValueProps {
	options?: Options<Option>;
	defaultValue?: Option;
	customMenu?: any;
	customValue?: any;
	customInput?: any;
	customControl?: any;
	isDisabled?: boolean;
}

export const SelectDate: FC<SelectValueProps> = ({
	options,
	defaultValue,
	customMenu,
	customValue,
	customControl,
	customInput,
	isDisabled = false,
}) => {
	const { isOpenCalendar } = useCalendarDatepicker();


	return (
		<Select
			styles={selectStyles}
			defaultValue={defaultValue}
			options={options}
			components={{
				Menu: customMenu ? customMenu : components.Menu,
				ValueContainer: customValue
					? customValue
					: components.ValueContainer,
				Input: customInput ? customInput : components.Input,
				Control: customControl ? customControl : components.Control,
				DropdownIndicator: () => (
					<ArrowContainer>
						<Img
							src={isOpenCalendar ? arrowTop : arrow}
							$size={'verySmall'}
						/>
					</ArrowContainer>
				),
			}}
			menuIsOpen={isOpenCalendar}
			isDisabled={isDisabled}
		/>
	);
};
